// src/routes/report/$reportId.tsx
import { createFileRoute } from "@tanstack/react-router"
import { Box, Container, Text, Spinner, Center } from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { ReportsService } from "@/client"
import { ReportContent } from "@/components/Reports/ReportContent"
import { ReportBreadcrumb } from "@/components/Reports/ReportBreadcrumb"

export const Route = createFileRoute("/_layout/report/$reportId")({
  component: ReportPage,
})

function ReportPage() {
  const { reportId } = Route.useParams()

  const { data: report, isLoading } = useQuery({
    queryKey: ["report", reportId],
    queryFn: () => ReportsService.getReportById({
        reportId: reportId
    }),
  })

  //won't run until report?.report_job_id exists
  //breadcrub에 사용
//   const { data: reportJob } = useQuery({
//     queryKey: ["reportJob", report?.report_job_id],
//     queryFn: () => ReportsService.getReportJob({ jobId: report!.report_job_id as string }),
//     enabled: !!report?.report_job_id,
//   })

  if (isLoading) {
    return (
      <Center w="100%" py={10}>
        <Spinner />
      </Center>
    )
  }

  if (!report) {
    return <Text>리포트를 찾을 수 없습니다.</Text>
  }

  return (
    <Container maxW="7xl" mt={4} display="flex" flexDirection="column">
        <ReportBreadcrumb
            reportJobId={report.report_job_id || ""}
            reportJobName={report.report_job_name || "리포트 생성 작업"}
            reportName={report.report_name || "리포트 목록"}
        />
        <Box flex="1" overflowY="auto">
          <ReportContent report={report} />
        </Box>
    </Container>
  )
}
